export const LocationStatuses = {
    'HQ': {
        title: 'Headquarters'
    },
    'BR': {
        title: 'Branch'
    },
    'SL': {
        title: 'Single Location'
    }
};